<template>
  <div id="publishing-journal-website-section">
    <site-search-group class="mar-b-40"
                       v-model.trim="params.name"
                       placeholder="Search by keywords"
                       @search="getList"
                       @clear="handleClear" />
    <div class="line-h-40 mar-b-20 ipub-p3 flex relative"
         style="height:40px;display: flex;align-items: center;justify-content: left;">
      <ipub-radio :checked="!displaySection"
                  @change="showSection">Not Display Sections on Website</ipub-radio>
      <div class="right-option ipub-p1">
        <ipub-button v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.SECTIONS.ADD')"
                     type="primary"
                     @click="add()">
          Add New Section
        </ipub-button>
        <ipub-button type="primary"
                     v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.SECTIONS.IMPORT')"
                     @click="imp()">
          Import
        </ipub-button>
      </div>
    </div>

    <div class="page-content">
      <ipub-table :columns="columns"
                  :pagination="false"
                  :dataSource="dataSource">
        <template v-slot:img="{text}">
          <img class="ipub-table-slot-img"
               :src="`${domain}/${text}`"
               alt="">
        </template>
        <template v-slot:time="{record}">
          {{ (record.updateTime||record.createTime)?$moment(record.updateTime||record.createTime).format('HH : mm DD / MM / YYYY'): '- -' }}
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.SECTIONS.EDIT')"
                        class="border-right">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="edit(record)" />
          </ipub-tooltip>
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.SECTIONS.DELETE')">
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="del(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <Add ref="journal-website-section-add"
         :isVisable="isVisable"
         :tree="dataSource"
         :hasSection="hasSection"
         @confirm="confirm"
         @cancel="cancel" />
    <import-dialog :isVisable="isVisableImport"
                   :journalId="params.journalId"
                   @confirm="confirm"
                   @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
